import { render } from "./QuickActionPanel.vue?vue&type=template&id=3ccb0ca1&scoped=true&ts=true"
import script from "./QuickActionPanel.vue?vue&type=script&lang=ts"
export * from "./QuickActionPanel.vue?vue&type=script&lang=ts"

import "./QuickActionPanel.vue?vue&type=style&index=0&id=3ccb0ca1&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccb0ca1"]])

export default __exports__